module.exports = __webpack_public_path__ + "img/luggage-01.f76e5518.svg";